<template>
  <v-footer app
    dark
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="accent py-4 text-center white--text"
        cols="12"
      >
        &copy; {{ new Date().getFullYear() }} — <strong>EntreGoals</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {

  name: 'Footer',

  data: () => ({
  }),
};
</script>

<style lang="css" scoped>
</style>
